import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import Heading from "../../components/Heading";
import ForgotPasswordForm from "./ForgotPasswordForm";

export const ForgotPasswordPage: FC = () => (
  <>
    <Heading
      title={<FormattedMessage id="login.forgotPassword.title" />}
      description={<FormattedMessage id="login.forgotPassword.description" />}
    />
    <ForgotPasswordForm />
  </>
);
